import { useQuery } from "@tanstack/react-query";
import { Customer, RentalWithRelations } from "@/types/models";
import { getRentalHistoryByCustomer } from "@/integrations/supabase/services";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface Props {
  customer: Customer | null;
  isOpen: boolean;
  onClose: () => void;
}

const RentalHistoryModal = ({ customer, isOpen, onClose }: Props) => {
  const { data: rentalHistory = [], isLoading } = useQuery<RentalWithRelations[]>({
    queryKey: ["rentalHistory", customer?.id],
    queryFn: () => getRentalHistoryByCustomer(customer!.id),
    enabled: !!customer,
  });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Historial de Alquileres de {customer?.name}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Fecha</TableHead>
                <TableHead>Modelo</TableHead>
                <TableHead>Duración</TableHead>
                <TableHead>Monto</TableHead>
                <TableHead>Estado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center">
                    Cargando historial...
                  </TableCell>
                </TableRow>
              ) : rentalHistory.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center">
                    No hay historial de alquileres para este cliente.
                  </TableCell>
                </TableRow>
              ) : (
                rentalHistory.map((rental) => (
                  <TableRow key={rental.id}>
                    <TableCell>{new Date(rental.start_date).toLocaleDateString()}</TableCell>
                    <TableCell>{rental.bike?.model}</TableCell>
                    <TableCell>{rental.duration_hours} horas</TableCell>
                    <TableCell>${rental.total_amount}</TableCell>
                    <TableCell>
                      <Badge variant={rental.status === 'completed' ? 'default' : 'secondary'}>
                        {rental.status}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RentalHistoryModal;
